(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-popup"] && !Shopify.designMode) return;
  try {
    
    class PopupAnnouncement extends HTMLElement {
        constructor() {
            super();
            this.onCloseClick = this.onCloseClick.bind(this);
            this.onEsc = this.onEsc.bind(this);
            this.onBackgroundClick = this.onBackgroundClick.bind(this);
            this.onInnerClick = this.onInnerClick.bind(this);
        }

        connectedCallback() {
            this.storageKey =
            this.getAttribute("storage-key") || "popupAnnouncementClosed";

            if (this.getStorage(this.storageKey) !== "true") {
            this.classList.add("popup--active");
            } else {
                return;
            }

            this.closeBtn = this.querySelector("[data-popup-close]");
            if (this.closeBtn) {
            this.closeBtn.addEventListener("click", this.onCloseClick);
            }
            this.inner = this.querySelector(".popup__inner");
            if (this.inner) {
            this.inner.addEventListener("click", this.onInnerClick);
            }
            document.addEventListener("keydown", this.onEsc);
        }

        disconnectedCallback() {
            if (this.closeBtn)
            this.closeBtn.removeEventListener("click", this.onCloseClick);

            if (this.inner)
            this.inner.removeEventListener("click", this.onInnerClick);

            document.removeEventListener("keydown", this.onEsc);
        }
        onBackgroundClick(e) {
        if (e.target === this) {
            this.closeAndRemember();
        }
        }

        onInnerClick(e) {
            //if (e.target.closest("[data-popup-close]")) return;
            this.setStorage(this.storageKey, "true");
        }

        onCloseClick() {
            this.closeAndRemember();
        }

        onEsc(e) {
            if (e.key === "Escape" && this.classList.contains("popup--active")) {
            this.closeAndRemember();
            }
        }

        closeAndRemember() {
            this.classList.remove("popup--active");
            this.setStorage(this.storageKey, "true");

            if (this.closeBtn)
            this.closeBtn.removeEventListener("click", this.onCloseClick);

            if (this.inner)
            this.inner.removeEventListener("click", this.onInnerClick);

            document.removeEventListener("keydown", this.onEsc);
        }

        getStorage(key) {
            try {
            return window.localStorage.getItem(key);
            } catch (e) {
                return null;
            }
        }
        setStorage(key, value) {
            try {
            window.localStorage.setItem(key, value);
            } catch (e){
                return null;
            }
        }
    }
    if (!customElements.get("popup-announcement"))
    customElements.define("popup-announcement", PopupAnnouncement);
    

  } catch(e) { console.error(e); }
})();
})();
